import React, { Component } from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { pxToRem, color, monthsNames } from '../../utils'
import { LockedIcon, UnlockedIcon } from '../icons'
import { reportActions } from '../../actions'

const Wrapper = styled.div`
  text-align: center;
`

const Box = styled.div`
  margin: 0 auto ${pxToRem(35)} auto;
  display: inline-flex;
  justify-content: center;
  background: #fff;
  border-radius: ${pxToRem('7px')};
  box-shadow: 0 ${pxToRem('5px')} ${pxToRem('30px')} 0 rgba(0, 0, 0, 0.25);
`

const CardsWrapper = styled.div``

const ReportCard = styled.a`
  margin-right: 25px;
  padding: ${pxToRem('10px')};
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  text-decoration: none;
  color: ${props => (props.selected ? '#ffffff' : '#6d6d6d')};
  background-color: ${props => (props.selected ? color.secondary : '#ffffff')};
  border-radius: ${pxToRem('7px')};
  strong {
    box-sizing: border-box;
    margin-bottom: 0;
  }
  p {
    box-sizing: border-box;
    margin-top: 0;
    margin-bottom: 5px;
  }
`

class ReportPicker extends Component {
  componentDidMount() {
    const { availableReports } = this.props
    const mostRecentReport = availableReports[availableReports.length - 1]

    this.props.changeCurrentReport(mostRecentReport)
  }

  getMonthName(month) {
    const monthName = monthsNames[month - 1]

    return monthName
  }

  render() {
    const { availableReports, currentReport, changeCurrentReport } = this.props

    const { getMonthName } = this
    return (
      <Wrapper>
        <Box>
          {availableReports.map(report => (
            <CardsWrapper>
              <ReportCard
                href="javascript:void(0)"
                onClick={event => changeCurrentReport(report)}
                selected={report.label === (currentReport || {}).label}
              >
                <strong>{getMonthName(report.month)}</strong>
                <p>{report.year}</p>
                <div>
                  {
                    report.locked ? 
                      <LockedIcon color={report.label === (currentReport || {}).label ? '#ffffff' : '#6d6d6d'}/>
                    :
                      <UnlockedIcon color={report.label === (currentReport || {}).label ? '#ffffff' : '#6d6d6d'}/>
                  }
                </div>
              </ReportCard>
            </CardsWrapper>
          ))}
        </Box>
      </Wrapper>
    )
  }
}

const mapStateToProps = state => ({
  currentReport: state.report.current_report
})

const mapDispatchToProps = dispatch => {
  return {
    changeCurrentReport: report => dispatch(reportActions.changeCurrentReport(report))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ReportPicker)



// WEBPACK FOOTER //
// ./src/components/Inventory/ReportPicker.js